import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from '@angular/core';
import { DesignUtilityServices } from 'src/app/appServices/design-utility.service';
import { RestaurantBasicInfoStorage } from 'src/app/appStorage/restaurant-basic-info.storage';
import { CheckoutResolver } from '../checkout.resolver';

@Component({
  selector: 'app-tip',
  templateUrl: './tip.component.html',
  styleUrls: ['./tip.component.scss'],
})
export class TipComponent implements OnInit {
  basicInfo: any;
  tipAmount: number = 0;
  gratuityTip: number = 0;
  tipList = [10, 15, 18, 20];
  gratuityTipList = [10, 15, 18, 20];
  tipToggleVal;

  @Input() subTotalAmount;

  constructor(
    private _du: DesignUtilityServices,
    private infoStorage: RestaurantBasicInfoStorage,
    private checkoutResolver: CheckoutResolver
  ) {
    this.getBasicInfo();
    this.checkoutResolver.tipToggleVal.subscribe((res) => {
      this.tipToggleVal = res;
    });
    this.checkoutResolver.tipAmount.subscribe((res) => {
      this.tipAmount = res;
    });
  }

  ngOnInit(): void {
    // this.calculateGratuityTip();
  }

  setTipAmount(tip: any): void {
    this.checkoutResolver.tipToggleVal.next(tip);
    if (tip !== 0 && tip !== 'custom') {
      this.tipAmount = Number.parseFloat(
        ((tip * this.subTotalAmount) / 100).toFixed(2)
      );
    } else {
      this.tipAmount = 0;
    }
    this.emitSelectedTipAmount(this.tipAmount);
  }
  setCustomTip(tip): void {
    this.emitSelectedTipAmount(tip);
  }
  calculateGratuityTip(): void {
    if (this.subTotalAmount >= 30) {
      this.gratuityTip = Number.parseFloat(
        ((10 * this.subTotalAmount) / 100).toFixed(2)
      );
      this._du.openCustomSnackBar(
        'A Gratuity tip has been added for orders that are 30 dollars or more. Tips are shared between all curbside waitress and cooks. Thank you for supporting our business and employees!',
        'Close',
        'info'
      );
      this.emitSelectedTipAmount(this.gratuityTip);
    } else {
      this.emitSelectedTipAmount(this.tipAmount);
    }
  }
  setGratuityTip(tip: any): void {
    if (tip !== 0) {
      this.gratuityTip = Number.parseFloat(
        ((tip * this.subTotalAmount) / 100).toFixed(2)
      );
      this.emitSelectedTipAmount(this.gratuityTip);
    }
  }

  emitSelectedTipAmount(amount): void {
    if (!amount) {
      amount = 0;
    }
    this.checkoutResolver.tipAmount.next(Number.parseFloat(amount));
  }

  /**
   * get basic information
   */
  getBasicInfo(): void {
    this.infoStorage.restaurantBasicInfo.subscribe((res) => {
      if (res) {
        this.basicInfo = res;
      }
    });
  }
}
